if (!customElements.get('board-comparison')) {
  customElements.define('board-comparison', class BoardComparison extends HTMLElement {
    connectedCallback() {
      const slides = [...this.querySelectorAll('[data-compare-copy]')];
      const copyTrack = this.querySelector('.twt-thickness__copy-track');
      const pill = this.querySelector('[data-compare-pill]');

      const applyMode = (mode) => {
        this.dataset.mode = mode;
        const active = slides.find((slide) => slide.dataset.compareCopy === mode);
        if (pill && active) pill.textContent = active.dataset.benefitLabel;
      };

      const scrollToSlide = (mode) => {
        const slide = slides.find((item) => item.dataset.compareCopy === mode);
        slide?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      };

      this.select = (mode) => {
        applyMode(mode);
        scrollToSlide(mode);
      };

      const step = (direction) => {
        const currentIndex = slides.findIndex((slide) => slide.dataset.compareCopy === this.dataset.mode);
        const next = slides[(currentIndex + direction + slides.length) % slides.length];
        this.select(next.dataset.compareCopy);
      };

      this.querySelector('[data-compare-prev]')?.addEventListener('click', () => step(-1));
      this.querySelector('[data-compare-next]')?.addEventListener('click', () => step(1));

      if (copyTrack && 'IntersectionObserver' in window) {
        const slideObserver = new IntersectionObserver(
          (entries) => {
            const mostVisible = entries
              .filter((entry) => entry.isIntersecting)
              .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
            if (mostVisible) applyMode(mostVisible.target.dataset.compareCopy);
          },
          { root: copyTrack, threshold: [0.6] }
        );
        slides.forEach((slide) => slideObserver.observe(slide));
      }

      applyMode(this.dataset.mode || 'stability');

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) {
            this.classList.add('is-visible');
            observer.disconnect();
          }
        }, { threshold: 0.25 });
        observer.observe(this);
      } else {
        this.classList.add('is-visible');
      }
    }
  });
}
